import React from "react";
import ActionBox from "@appComponents/ActionBox/ActionBox";
import { IBankAccountProperties } from "@funds/components/WithdrawAmount/IWithdrawAmount";
import { Form } from "antd";
import { FormikProps } from "formik";
import Flag from "@appComponents/Flag/Flag";
import { displayBankNumber } from "@features/utils/functions";


import * as style from './BankAccountOptionStyles.module.scss'

export type Props = {
  bankAccount: IBankAccountProperties;
  checked: boolean;
  onActionBoxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fee: number;
  accountBlocked: boolean;
};

const BankAccountOption = ({
  bankAccount,
  checked,
  onActionBoxChange,
  fee,
  accountBlocked,
}: Props) => (
  <div key={bankAccount.id}>
    <Form.Item label="Select bank account">
      <ActionBox
        type={
          bankAccount.status === "email_sent" ||
          bankAccount.status === "pending" ||
          accountBlocked
            ? "empty"
            : "radio"
        }
        key={bankAccount.id}
        headline={
          <>
            <p>{bankAccount.name}</p>&nbsp;
            <Flag slug={bankAccount.country} />
          </>
        }
        text={
          <>
            <p>
              {displayBankNumber(
                bankAccount.iban || bankAccount.account_number
              )}
            </p>
            {bankAccount.status === "pending" ? (
              <p className={style.requestedLabel}>
                This account is currently being reviewed. Once approved, you
                will be able to use this account for withdrawals. Note: you can
                only have one active account on your profile.
              </p>
            ) : bankAccount.status === "email_sent" ? (
              <p className={style.requestedLabel}>
                This account cannot be used for withdrawal purposes yet. It must
                be confirmed first, check your inbox.
              </p>
            ) : (
              <p>Transaction Fee: ${fee} USD</p>
            )}
          </>
        }
        isRequested={
          bankAccount.status === "email_sent" ||
          bankAccount.status === "pending"
        }
        radioKey={`bank${bankAccount.id}`}
        radioAttr={{
          checked,
          value: bankAccount.id,
          onChange: onActionBoxChange,
          name: "selectedWallet",
          "data-usdtype": "normal",
          "data-country": bankAccount.holder_address?.country,
        }}
      />
    </Form.Item>
  </div>
);

export default BankAccountOption;
